
    <mat-form-field appearance="outline" [style.width]="width" subscriptSizing="dynamic">
      <mat-label *ngIf="label">{{ label }}</mat-label>
      <input matInput type="text" [formControl]="ctrl" [matAutocomplete]="auto"
             [placeholder]="placeholder" (input)="onInput()" (blur)="onBlur()">
      <br-icon matSuffix style="color:#5f6368;">schedule</br-icon>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelect($event.option.value)">
        <mat-option *ngFor="let o of filtered" [value]="o.value">{{ o.label }}</mat-option>
      </mat-autocomplete>
    </mat-form-field>
